import styled from "styled-components";
import { Link } from "react-router-dom";
import { Card1 } from "components/Form/Card1";
import { ReactNode } from "react";

const Header = styled(Card1)`
  z-index: 9999;

  @media (max-width: 761px) {
    flex-direction: row;
  }
  @media (max-width: 480px) {
    // gap: 4rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.div`
  width: 200px;
  height: 51px;
  display: block;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 768px) {
    width: 180px;
    height: auto;

    img {
      height: auto;
    }
  }

  @media (max-width: 480px) {
    width: 140px;
    height: auto;
  }
`;

const Nav = ({ children }: { children?: ReactNode }) => {
  return (
    <Header
      as="header"
      className="d-flex justify-content-between align-items-center mx-4 pt-1"
    >
      <LogoContainer>
        <Link to="/" aria-label="RedMorphX home">
          <LogoImage>
            <img
              src="/RedMorph_logo_218.webp"
              // src="/RedMorph_logo.webp"
              // srcSet="/RedMorph_logo-180.webp 1x, /RedMorph_logo.webp 2x"
              alt="RedMorphX"
              width={180}
              height={46}
              // fetchPriority="high"
              decoding="async"
            />
          </LogoImage>
        </Link>
      </LogoContainer>

      <div className="d-flex align-items-center gap-2">{children}</div>
    </Header>
  );
};

export default Nav;
